<template>
  <div>
      <v-row>
          <v-col cols="12" md="6" lg=12>
              <v-card style="max-width: 400px"
                      class="mx-auto IMThemeGray rounded-xl rounded-tl-0 EK-card action-form">
                  <v-form ref="subsForm" v-model="valid">
                      <v-card-text class="text-right rounded-tl-0">
                          <v-card-title class="text-white justify-content-center">
                              تعديل الاشتراك
                          </v-card-title>
                          <label for="shopId" class="text-light">المشترك</label>
                          <v-autocomplete id="shopId"
                                          v-model="subsForm.shopId"
                                          :rules="shopId"
                                          :items="shopsList"
                                          item-text="name"
                                          item-value="id"
                                          dense
                                          rounded
                                          class="rounded-xl rounded-tl-0"
                                          color="IMThemeGray"
                                          item-color="IMThemeGray"
                                          solo
                                          @change="GetDropDownDetails(subsForm.shopId)">
                              <template v-slot:item="data">
                                  <v-list-item-content v-text="data.item.name"></v-list-item-content>
                              </template>
                          </v-autocomplete>
                          <v-row>
                              <v-col :lg="subsForm.subsType == 1 || subsForm.subsType == 2 || subsForm.subsType == 3 ? 7 : 12" sm="12">
                                  <label for="subsType" class="text-light">نوع الاشتراك</label>
                                  <v-select id="subsType"
                                            v-model="subsForm.subsType"
                                            :rules="subsType"
                                            :disabled="subsForm.shopId == null"
                                            :items="subsTypes"
                                            item-text="name"
                                            item-value="id"
                                            color="IMThemeGray"
                                            item-color="IMThemeGray"
                                            dense
                                            solo
                                            class="rounded-xl rounded-tl-0"
                                            @change="GetSubsTypeDate(subsForm.subsType)"></v-select>
                              </v-col>
                              <v-col lg="5" sm="12" v-if="subsForm.subsType == 1">
                                  <label for="subsType" class="text-light">عدد الاشعارات</label>
                                  <v-text-field id="notifiCount"
                                                v-model.number="subsForm.notiSubsCount"
                                                :rules="notifiCount"
                                                dense
                                                color="dark"
                                                solo
                                                rounded
                                                class="rounded-tr-0"
                                                dir="ltr"
                                                type="number"></v-text-field>
                              </v-col>
                              <v-col lg="5" sm="12" v-if="subsForm.subsType == 2">
                                  <label for="subsType" class="text-light">عدد الصور المتاح</label>
                                  <v-text-field id="notifiCount2"
                                                v-model.number="subsForm.imgSubsCount"
                                                :rules="notifiCount"
                                                dense
                                                color="dark"
                                                solo
                                                rounded
                                                class="rounded-tr-0"
                                                dir="ltr"
                                                type="number"></v-text-field>
                                  <label for="subsType" class="text-light">عدد الصور المنشورة</label>

                                  <v-text-field  
                                                v-model.number="subsForm.imgSubsCountUsed"
                                                disabled
                                                dense
                                                color="dark"
                                                solo
                                                rounded
                                                class="rounded-tr-0"
                                                dir="ltr"
                                                type="number"></v-text-field>
                              </v-col>
                              <v-col lg="5" sm="12" v-if="subsForm.subsType == 3">
                                  <label for="subsType" class="text-light">عدد العروض المتاح</label>
                                  <v-text-field id="notifiCount4"
                                                v-model.number="subsForm.offerSubsCount"
                                                :rules="notifiCount"
                                                dense
                                                color="dark"
                                                solo
                                                rounded
                                                class="rounded-tr-0"
                                                dir="ltr"
                                                type="number"></v-text-field>
                                  <label for="subsType" class="text-light">عدد العروض المنشورة</label>

                                  <v-text-field v-model.number="subsForm.offerSubsCountUsed"
                                                disabled
                                                dense
                                                color="dark"
                                                solo
                                                rounded
                                                class="rounded-tr-0"
                                                dir="ltr"
                                                type="number"></v-text-field>
                              </v-col>
                          </v-row>
                          <label for="subscribeDates" class="text-light">تاريخ الاشتراك الجديد</label>
                          <v-menu ref="subscribeDatesMenu"
                                  v-model="subscribeDatesMenu"
                                  :close-on-content-click="false"
                                  :return-value.sync="subsForm.subscribeDates"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                  <v-list-item class="white rounded-tl-0 rounded-xl"
                                               v-bind="attrs"
                                               v-on="on"
                                               dense>
                                      <v-chip small v-for="date in subsForm.subscribeDates" class="ml-1" :key="date">
                                          {{ date }}
                                      </v-chip>
                                      <v-icon class="mr-auto">mdi-calendar</v-icon>
                                  </v-list-item>
                              </template>
                              <v-date-picker v-model="subsForm.subscribeDates"
                                             :disabled="subsForm.subsType == null"
                                             locale="ar-sy"
                                             color="IMThemeGray"
                                             range>
                                  <v-spacer></v-spacer>
                                  <v-btn text
                                         color="IMThemeGray"
                                         @click="subscribeDatesMenu = false">
                                      Cancel
                                  </v-btn>
                                  <v-btn text
                                         color="IMThemeGray"
                                         @click="$refs.subscribeDatesMenu.save(subsForm.subscribeDates)">
                                      OK
                                  </v-btn>
                              </v-date-picker>
                          </v-menu>
                          <small class="text-danger" v-if="isValidSubscribeDates">الحقل يجب أن يحتوي على تاريخين - تاريخ البداية فيه أصغر من تاريخ النهاية</small>
                      </v-card-text>
                      <v-card-actions class="justify-content-around pb-4">
                          <v-btn @click="SubmitSetSubscription()"
                                 rounded
                                 class="rounded-tl-0 px-12"
                                 :disabled="!valid || isValidSubscribeDates">تم</v-btn>
                          <v-btn class="rounded-tl-0 px-6 text-dark"
                                 rounded
                                 color="error"
                                 :disabled="subsForm.subsType == null || subsForm.subsType == 0"
                                 @click="SubmitRemoveSubscription(subsForm.subsType)"
                                 transition="slide-x-transition">
                              حذف
                              <img src="/media/svg/table/delete.svg" alt="delete" class="pr-2" />
                          </v-btn>
                      </v-card-actions>
                  </v-form>
              </v-card>
          </v-col>
          <v-col cols="12" md="6" lg=12>
              <v-card style="max-width: 400px"
                      class="mx-auto IMThemeGray rounded-xl rounded-tl-0 EK-card">
                  <v-card-text class="text-right rounded-tl-0">
                      <v-card-title class="text-white justify-content-center">
                          فلترة الاشتراكات
                      </v-card-title>
                      <v-col cols="12">
                          <v-form v-model="validFilter">
                              <v-row>
                                  <v-col cols="12">
                                      <label for="subscribeDates" class="text-light">تاريخ إنتهاء الإشتراك</label>
                                      <v-menu ref="endSubscribeDatesmenu"
                                              v-model="endSubscribeDatesmenu"
                                              :close-on-content-click="false"
                                              :return-value.sync="subsExtenedForm.subscribeDates"
                                              transition="scale-transition"
                                              offset-y
                                              min-width="auto">
                                          <template v-slot:activator="{ on, attrs }">
                                              <v-list-item class="white rounded-tl-0 rounded-xl"
                                                           v-bind="attrs"
                                                           v-on="on"
                                                           dense>
                                                  <v-chip small v-for="date in subsExtenedForm.subscribeDates" class="ml-1" :key="date">
                                                      {{ date }}
                                                  </v-chip>
                                                  <v-icon class="mr-auto">mdi-calendar</v-icon>
                                              </v-list-item>
                                          </template>
                                          <v-date-picker v-model="subsFilterForm.subscribeDates"
                                                         locale="ar-sy"
                                                         color="IMThemeGray"
                                                         range>
                                              <v-spacer></v-spacer>
                                              <v-btn text
                                                     color="IMThemeGray"
                                                     @click="endSubscribeDatesmenu = false">
                                                  Cancel
                                              </v-btn>
                                              <v-btn text
                                                     color="IMThemeGray"
                                                     @click="$refs.endSubscribeDatesmenu.save(subsFilterForm.subscribeDates)">
                                                  OK
                                              </v-btn>
                                          </v-date-picker>
                                      </v-menu>
                                      <small class="text-danger" v-if="isValidEndSubscribeDate">الحقل يجب أن يحتوي على تاريخين - تاريخ البداية فيه أصغر من تاريخ النهاية</small>
                                  </v-col>
                                  <v-col cols="6">
                                      <label for="subsType" class="text-light">نوع الاشتراك</label>
                                      <v-select id="filterSubsType"
                                                v-model="subsFilterForm.subsType"
                                                :items="subsTypes"
                                                item-text="name"
                                                item-value="id"
                                                color="IMThemeGray"
                                                item-color="IMThemeGray"
                                                dense
                                                solo
                                                class="rounded-xl rounded-tl-0"></v-select>
                                  </v-col>
                                  <v-col cols="6" class="pt-6">
                                      <v-checkbox dark
                                                  color="IMThemeOrange"
                                                  v-model="subsFilterForm.outDated"
                                                  label="المنتهي فقط"></v-checkbox>
                                  </v-col>
                                  <v-col cols="12" class="text-center">
                                      <v-btn :disabled="!validFilter || isValidEndSubscribeDate"
                                             @click="filterItSubscription"
                                             rounded
                                             class="rounded-tl-0 px-12">
                                          تم
                                      </v-btn>
                                      <v-btn @click="resetFilter"
                                             outlined
                                             rounded
                                             dark
                                             color="error"
                                             class="rounded-tl-0 mr-4 px-12">تهيئة الفلترة</v-btn>
                                  </v-col>
                              </v-row>
                          </v-form>
                      </v-col>
                  </v-card-text>
              </v-card>
          </v-col>

          <v-col cols="12" md="6" lg=12>
              <v-card style="max-width: 400px"
                      class="mx-auto IMThemeGray rounded-xl rounded-tl-0 EK-card action-form">
                  <v-form ref="subsForm" v-model="valid">
                      <v-card-text class="text-right rounded-tl-0">
                          <v-card-title class="text-white justify-content-center">
                              تمديد الاشتراكات
                          </v-card-title>
                          <v-col cols="12">
                              <label for="subscribeDates" class="text-light">تمديد الاشتراكات ذات تواريخ الانتهاء</label>
                              <v-menu ref="extendSubscribeDatesmenu"
                                      v-model="extendSubscribeDatesmenu"
                                      :close-on-content-click="false"
                                      :return-value.sync="subsExtenedForm.subscribeDates"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="auto">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-list-item class="white rounded-tl-0 rounded-xl"
                                                   v-bind="attrs"
                                                   v-on="on"
                                                   dense>
                                          <v-chip small v-for="date in subsExtenedForm.subscribeDates" class="ml-1" :key="date">
                                              {{ date }}
                                          </v-chip>
                                          <v-icon class="mr-auto">mdi-calendar</v-icon>
                                      </v-list-item>
                                  </template>
                                  <v-date-picker v-model="subsExtenedForm.subscribeDates"
                                                 locale="ar-sy"
                                                 color="IMThemeGray"
                                                 range>
                                      <v-spacer></v-spacer>
                                      <v-btn text
                                             color="IMThemeGray"
                                             @click="extendSubscribeDatesmenu = false">
                                          Cancel
                                      </v-btn>
                                      <v-btn text
                                             color="IMThemeGray"
                                             @click="$refs.extendSubscribeDatesmenu.save(subsExtenedForm.subscribeDates)">
                                          OK
                                      </v-btn>
                                  </v-date-picker>
                              </v-menu>
                              <small class="text-danger" v-if="isValidExtendSubscribeDate">الحقل يجب أن يحتوي على تاريخين - تاريخ البداية فيه أصغر من تاريخ النهاية</small>
                          </v-col>
                          <v-col cols="12" sm="6" md="12">

                              <v-col :lg="subsForm.subsType == 1 ? 7 : 12" sm="12">
                                  <label for="subsType" class="text-light">نوع الاشتراك</label>
                                  <v-select id="filterSubsType"
                                            v-model="subsExtenedForm.subsType"
                                            :items="subsTypes"
                                            item-text="name"
                                            item-value="id"
                                            color="IMThemeGray"
                                            item-color="IMThemeGray"
                                            dense
                                            solo
                                            class="rounded-xl rounded-tl-0"></v-select>
                              </v-col>

                          </v-col>
                          <v-col cols="12" sm="6" md="12">
                              <label for="subscribeDates" class="text-light">تمديد الاشتراكات ل (عدد أيام)</label>

                              <v-text-field dense
                                            solo
                                               type="number"
                                            v-model="subsExtenedForm.days"

                                            class="rounded-xl rounded-tl-0"
                                            id="fullName"></v-text-field>
                          </v-col>

                      </v-card-text>
                      <v-card-actions class="justify-content-around pb-4">
                          <v-btn @click="SubmitExtendSubscription()"
                                 rounded
                                 class="rounded-tl-0 px-12"
                                 :disabled="!valid || isValidSubscribeDates">تمديد</v-btn>
                     
                      </v-card-actions>
                  </v-form>
              </v-card>
          </v-col>
      </v-row>
  </div>
</template>
<style lang="scss">
.v-text-field__slot input {
  padding-right: 6px !important;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  data: () => ({
    valid: false,
    validFilter: false,
    subscribeDatesMenu: false,
        endSubscribeDatesmenu: false,
        extendSubscribeDatesmenu: false,
    isValidSubscribeDates: false,
        isValidEndSubscribeDate: false,
        isValidExtendSubscribeDate: false,

    shopId: [(v) => !!v || "يرجى اختيار مشترك"],
    subsType: [(v) => v != null || "يرجى اختيار نوع اشتراك"],
    notifiCount: [(v) => !!v || "يرجى كتابة عدد"],
  }),
  props: {
    id: String,
  },
  created() {
    this.fetchShopsList();
    if (this.id != -1) {
      this.fetchSubsForm(this.id);
    }
    this.offset = this.getOffset( document.querySelector('.action-form') ).top; 
    setTimeout(() => {
        window.scrollTo(this.offset, this.offset)
    }, 100)
  },
  computed: {
      ...mapGetters(["subsList", "subsForm", "shopsList", "subsTypes", "subsFilterForm", "subsExtenedForm"]),
  },
  methods: {
    getOffset( el ) {
        var _x = 0;
        var _y = 0;
        while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
            _x += el.offsetLeft - el.scrollLeft;
            _y += el.offsetTop - el.scrollTop;
            el = el.offsetParent;
        }
        return { top: _y, left: _x };
    },
    ...mapActions([
      "fetchSubsForm",
      "fetchShopsList",
        "SetSubscription",
        "ExtendSubscription",

      "RemoveSubscription",
      "filterItSubscription",
      "resetFilter",
    ]),
    GetDropDownDetails(id) {
      const shopIndex = this.subsList.findIndex((item) => item.shopId == id);
      if (shopIndex != this.id) {
        this.$refs.subsForm.reset();
        this.$router.push("./" + shopIndex);
      }
    },
    GetSubsTypeDate(type) {
      switch (type) {
        case 0: //اساسي
          this.subsForm.subscribeDates = [
            new Date(this.subsForm.subscribeStartDate).toISOString().substr(0, 10),
            new Date(this.subsForm.subscribeEndDate).toISOString().substr(0, 10),
          ];
          break;
        case 1: //اشعارات
          this.subsForm.subscribeDates = [
            new Date(this.subsForm.notiSubsStart).toISOString().substr(0, 10),
            new Date(this.subsForm.notiSubsEnd).toISOString().substr(0, 10),
          ];
          break;
        case 2: //صور
          this.subsForm.subscribeDates = [
            new Date(this.subsForm.imgSubsStart).toISOString().substr(0, 10),
            new Date(this.subsForm.imgSubsEnd).toISOString().substr(0, 10),
          ];
          break;
        case 3: // عروض
          this.subsForm.subscribeDates = [
            new Date(this.subsForm.offerSubsStart).toISOString().substr(0, 10),
            new Date(this.subsForm.offerSubsEnd).toISOString().substr(0, 10),
          ];
          break;
        default:
          this.subsForm.subscribeDates = [
            new Date().toISOString().substr(0, 10),
            new Date().toISOString().substr(0, 10),
          ];
      }
    },
    SubmitSetSubscription() {
      this.SetSubscription(this.subsForm);
      this.$refs.subsForm.reset();
      if (this.id != -1) {
        this.$router.push("./-1");
      }
      },

      SubmitExtendSubscription() {
          const swalWithBootstrapButtons = Swal.mixin({
              customClass: {
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-danger",
              },
              buttonsStyling: true,
          });
          swalWithBootstrapButtons
              .fire({
                  title: "هل أنت متأكد؟",
                  text: `هل تريد فعلاً تمديد الاشتراكات في المدة المحددة؟`,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "نعم!",
                  cancelButtonText: "إلغاء",
                  reverseButtons: false,
              })
              .then((result) => {
                  if (result.value) {
                      this.ExtendSubscription(this.subsExtenedForm);
                      this.$refs.subsExtenedForm.reset();
                      
                  }
              });

      
      },
    SubmitRemoveSubscription(subsType) {
      if (subsType != null) {
        const subsName = this.subsTypes[subsType].name;
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: true,
        });
        swalWithBootstrapButtons
          .fire({
            title: "هل أنت متأكد؟",
            text: `هل فعلاً تريد حذف اشتراك ${subsName}؟`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "نعم!",
            cancelButtonText: "إلغاء",
            reverseButtons: false,
          })
          .then((result) => {
            if (result.value) {
              this.RemoveSubscription({
                index: this.id,
                type: subsType,
              });
              this.$refs.subsForm.reset();
              if (this.id != -1) {
                this.$router.push("./-1");
              }
            }
          });
      }
    },
  },
  watch: {
    'subsForm.subscribeDates'(v) {
        this.isValidSubscribeDates = !(!!v && v.length == 2 && new Date(v[1]) > new Date(v[0]));
    },
    'subsFilterForm.subscribeDates'(v) {
        this.isValidEndSubscribeDate = !(!!v && v.length == 2 && new Date(v[1]) > new Date(v[0]));
      },
      'subsExtenedForm.subscribeDates'(v) {
          this.isValidEndSubscribeDate = !(!!v && v.length == 2 && new Date(v[1]) > new Date(v[0]));
      },
    id(newId) {
      if (newId != -1) {
        this.$refs.subsForm.reset();
        this.fetchSubsForm(this.id);
      }
      this.offset = this.getOffset( document.querySelector('.action-form') ).top; 
    setTimeout(() => {
        window.scrollTo(this.offset, this.offset)
    }, 100)
    },
  },
};
</script>
